import React from 'react';

function CustomerVatCodeField({ data }) {
  if (data.customerType === 'customerExtra') {
    return <>{data.customer?.taxCode}</>;
  } else if (data.customerType === 'condos') {
    return <>{data.customer?.vatCode}</>;
  } else {
    return <>-</>;
  }
}

export default CustomerVatCodeField;
